module.exports = __webpack_public_path__ + "img/icon_sns_04.dc20a25d.svg";